import React, { useState } from "react";
import { ReactComponent as Calender } from "../../assets/icons/calender.svg";
import { ReactComponent as ArrowIcon } from "../../assets/icons/appointment.svg";
import { colors } from "./../../share/constants/enums";
import Button from "../../components/common/button";
import { ClockCircleOutlined } from "@ant-design/icons";
import profileImage from "../../assets/icons/Avatar.png";

import Face from "./../../assets/icons/Face.png";
import { message, Input, DatePicker, Popover, Select, Avatar } from "antd";
import { appointmentRescheduled } from "../../api/appointments";
import moment from "moment";

const { Option } = Select;
const AppointmentCard = ({
  data,
  openModal,
  render,
  setRender,
  setDate,
  setTime,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  const [selectedHour, setSelectedHour] = useState("12");
  const [selectedMinute, setSelectedMinute] = useState("00");
  const [selectedAmPm, setSelectedAmPm] = useState("AM");
  const [displayedTime, setDisplayedTime] = useState("");
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [isRescheduleClicked, setIsRescheduleClicked] = useState(false);

  const formattedDateTime = moment
    .utc(data?.dateTime)
    .format("MM/DD/YYYY hh:mm a");
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleHourChange = (value) => {
    setSelectedHour(value);
  };

  const handleMinuteChange = (value) => {
    setSelectedMinute(value);
  };

  const handleAmPmChange = (value) => {
    setSelectedAmPm(value);
  };

  const handleOkClick = () => {
    const formattedHour = selectedHour.padStart(2, "0");
    const formattedMinute = selectedMinute.padStart(2, "0");
    // const formattedHourr =
    //   selectedAmPm === "PM" && selectedHour !== 12
    //     ? (parseInt(selectedHour) + 12).toString().padStart(2, "0")
    //     : selectedHour.padStart(2, "0");
    let formattedHourr;
    if (selectedAmPm === "PM") {
      formattedHourr =
        selectedHour !== "12" ? parseInt(selectedHour) + 12 : "12";
    } else {
      formattedHourr =
        selectedHour !== "12" ? selectedHour.padStart(2, "0") : "00";
    }
    const formattedTime = `${formattedHour}:${formattedMinute} ${selectedAmPm}`;
    const formattedAPITime = `${formattedHourr}:${formattedMinute}:00`;
    setDisplayedTime(formattedTime);
    setSelectedTime(formattedAPITime);
    setPopoverOpen(false);
  };

  const handleSaveClick = async () => {
    const timeWithDate = `${
      selectedDate?.toISOString().split("T")[0]
    }T${selectedTime}.000+00:00`;
    const payload = {
      dateTime: timeWithDate,
    };
    const res = await appointmentRescheduled(data?._id, payload);
    if (res) {
      message.success("Appointment Rescheduled Successfully!");
      setRender(!render);
      setSelectedDate(null);
      setSelectedTime(null);
      setSelectedHour("12");
      setSelectedMinute("00");
      setSelectedAmPm("AM");
      setDisplayedTime("");
    }

    setIsRescheduleClicked(false);
  };
  const handleRescheduleClick = () => {
    setIsRescheduleClicked((prevState) => !prevState);
  };
  const timePickerContent = (
    <div className="flex flex-col h-10">
      <div className="grid grid-cols-3 gap-1 w-31 h-2.5">
        <Select
          defaultValue="12"
          onChange={handleHourChange}
          className="border-primaryBlue h-14 w-2.4 mb-4"
        >
          {[...Array(12).keys()].map((hour) => (
            <Option key={hour + 1}>
              {hour + 1 < 10 ? `0${hour + 1}` : hour + 1}
            </Option>
          ))}
        </Select>
        <Select
          defaultValue="00"
          onChange={handleMinuteChange}
          className="border-primaryBlue h-1.4 w-2.4 "
        >
          {[...Array(60).keys()].map((minute) => (
            <Option key={minute}>{minute < 10 ? `0${minute}` : minute}</Option>
          ))}
        </Select>
        <Select
          defaultValue="AM"
          onChange={handleAmPmChange}
          className="border-primaryBlue h-5.4 w-2.4 "
        >
          <Option value="AM">AM</Option>
          <Option value="PM">PM</Option>
        </Select>
      </div>
      <Button
        type="primary"
        onClick={handleOkClick}
        className="w-30.5 h-5.4 mt-4 bg-primaryBlue"
        title={"Save"}
      />
    </div>
  );
  return (
    <div className="w-full flex flex-col items-center lg:grid mb-2 border border-solid shadow-md border-inputFieldGrey">
      <div className="grid grid-cols-2 w-full justify-items-center py-2 border-boxGrey border rounded-sm shadow-md bg-white justify-center md:grid md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 sm:grid sm:justify-center sm:grid-cols-2 ">
        <div className="items-center justify-center">
          <p className="font-bold justify-center mx-3 text-primaryPurple">
            Customer
          </p>
          <div className="flex items-center ml-2">
            {data?.user?.profileImage ? (
              <img
                src={data?.user?.profileImage}
                className="w-3 h-3 rounded-full"
                alt="Profile pic"
              />
            ) : (
              <img src={profileImage} className="w-3 h-3 rounded-full" />
            )}

            <span className=" ml-1 font-medium ">
              {data?.user?.firstName} {}
              {data?.user?.lastName}
            </span>
          </div>
        </div>
        <div>
          <p className="font-bold text-primaryPurple">Service Name</p>
          {data?.serviceDetails?.serviceName ? (
            <p className="mt-2 font-medium">{data?.serviceDetails?.serviceName}</p>
          ) : (
            <p className="mt-2 font-medium">{data?.service?.serviceName}</p>
          )}
        </div>
        <div className="items-center justify-center lg:mx-3 xl:mx-3 xl:h-full">
          <p className="font-bold text-primaryPurple">Appointment #</p>
          <p className="font-medium">{data?._id?.slice(-6)}</p>
        </div>
        <div className="bg-blue border border-gray-200 rounded items-center justify-center lg:mx-3 xl:mx-3 xl:h-full">
          <p className="font-bold items-center justify-center text-primaryPurple">
            Date and Time
          </p>
          <p className="mt-2 font-medium">{formattedDateTime}</p>
        </div>
        <div className="hidden lg:block"></div>
        {/* <div></div> */}
        <div className="flex items-center col-span-2 gap-4 justify-center">
          <Popover content={"Feature Coming Soon"}>
            <Calender className="cursor-pointer" />
          </Popover>
          <Button
            className="w-10"
            color={colors.primaryPurple}
            title="Reschedule"
            onClick={handleRescheduleClick}
          />
          <div
            onClick={openModal}
            className="mt-1 hover:cursor-pointer flex items-center justify-center"
          >
            <Popover content={"Feature Coming Soon"}>
              <ArrowIcon />
            </Popover>
          </div>
        </div>

        {/* <div className="w-15 flex items-center justify-center"></div> */}
      </div>
      {isRescheduleClicked && (
        <div className="grid mb-2 px-2 gap-3 sm:grid sm:grid-cols-1  md:grid-cols-3 md:px-2 md:mb-2 lg:grid-cols-3">
          <div className="bg-blue border border-gray-200  rounded  ">
            <p className="font-bold text-primaryPurple">Available Date</p>
            <DatePicker
              value={selectedDate}
              placeholder="Select Date"
              onChange={handleDateChange}
              format="MM-DD-YYYY"
              disabledDate={(current) => {
                const today = new Date();
                const currentDate = new Date(current);
                return currentDate < today;
              }}
              className="border border-primaryBlue h-5.4 w-full rounded-md text-lg pl-2 flex justify-between text-grey text-sm"
            />
          </div>
          <div className="bg-blue border border-gray-200  rounded lg:mx-3 xl:mx-3 xl:h-full">
            <p className="font-bold text-primaryPurple">Available Time</p>
            <Popover
              content={timePickerContent}
              trigger="click"
              placement="bottom"
              open={popoverOpen}
              onOpenChange={(newOpen) => setPopoverOpen(newOpen)}
            >
              <Input
                placeholder="Select Time"
                value={displayedTime}
                className="border-1.5 border-primaryBlue w-full h-5.4 rounded-md text-lg pl-2 flex justify-between text-grey text-sm"
                suffix={<ClockCircleOutlined style={{ color: "grey" }} />}
              />
            </Popover>
          </div>
          <div className="flex justify-center w-full">
            <Button
              title="Save"
              onClick={handleSaveClick}
              className="w-full xl:w-19 bg-primaryBlue mt-5"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AppointmentCard;
